module.exports = __webpack_public_path__ + "static/media/03.1955d8c9.png";